import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { Create } from 'react-admin'
import UpsellingForm from 'ui-shared/Forms/UpsellingForm'

const VirtualExperienceUpsellingCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <UpsellingForm relatedProduct="virtuals" />
      </Create>
    </SectionWrapper>
  )
}

export default VirtualExperienceUpsellingCreate
